import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "not-found-section relative py-32 overflow-hidden bg-[#1E2652] min-h-screen flex items-center justify-center" }
const _hoisted_2 = { class: "container relative z-10 mx-auto px-6 text-center" }


export default /*@__PURE__*/_defineComponent({
  __name: 'NotFoundPage',
  setup(__props) {

  // No additional logic needed for this page
  
return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "absolute inset-0" }, [
      _createElementVNode("div", { class: "absolute inset-0 bg-grid opacity-10" }),
      _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-b from-[#B7E000]/10 to-transparent" })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "text-6xl font-bold text-white mb-4" }, "404", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-2xl text-gray-400 mb-8" }, " Page Non Trouvée ", -1)),
      _createVNode(_component_router_link, {
        to: "/",
        class: "btn-primary inline-block"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(" Retour à l'Accueil ")
        ])),
        _: 1
      })
    ])
  ]))
}
}

})